var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Get User's Current Location")]),_c('button',{on:{"click":_vm.getLocation}},[_vm._v("Get My Location")]),_c('div',{staticStyle:{"height":"400px","width":"100%"},attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }